import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';

const NavbarVerticalMenuItem = ({ route }) => {
  return (
    <Flex alignItems="center">
      {route.img ? (
        <img
          src={route.img}
          alt={route.name}
          style={{
            width: '18px',
            marginRight: '8px',
            filter:
              'invert(20%) sepia(90%) hue-rotate(100deg) saturate(500%) brightness(80%)'
          }}
        />
      ) : (
        route.icon && (
          <span className="nav-link-icon">
            {React.isValidElement(route.icon)
              ? route.icon
              : React.createElement(route.icon)}
          </span>
        )
      )}
      <span className="nav-link-text ps-1" style={{ fontSize: '0.9rem' }}>
        {route.name}
      </span>
      {route.badge && (
        <SoftBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text}
        </SoftBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.node
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
